import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

const Counter = ({ value, decimals = 0, suffix = "" }) => {
  const { lang } = useLang();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) =>
        setDisplay(
          v.toLocaleString(lang === "it" ? "it-IT" : "en-US", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          })
        ),
    });
    return () => controls.stop();
  }, [inView, value, decimals, lang]);

  return (
    <span className="stat-value" ref={ref}>
      {display}
      <b>{suffix}</b>
    </span>
  );
};

const Stats = () => {
  const { t } = useLang();
  return (
    <section className="stats-band" aria-label={t.stats.note} data-testid="stats-section">
      <div className="shell stats-grid">
        {t.stats.items.map((s, i) => (
          <Reveal key={s.label} className="stat-cell" delay={i * 0.08}>
            <Counter value={s.value} decimals={s.decimals || 0} suffix={s.suffix} />
            <span className="stat-label">{s.label}</span>
          </Reveal>
        ))}
      </div>
      <div className="shell stats-note">{t.stats.note}</div>
    </section>
  );
};

export default Stats;
